module.exports = __webpack_public_path__ + "media/images/loading-spinner-011aaec08f5bee7eaa268cdb6aef12de.gif";